/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createEvaluate } from '../../factoriesAny.js';
export var evaluateDependencies = {
  parseDependencies: parseDependencies,
  typedDependencies: typedDependencies,
  createEvaluate: createEvaluate
};